<template>
  <product
    :product-logo="productLogo"
    :product-brief="productBrief"
    :carousel-images="carouselImages"
  >
    <p>
      ONE App is spearheaded by university students in the US. The film
      industry has many established practices formed over a hundred
      years. And it's hard to disrupt those. So a networking app like
      this could be welcomed.
    </p>
    <p>
      The app features a rich profile with a bio, daily rate, showcase
      of your work in the industry (Posters/videos/project
      samples/etc.). Then, there's a project planning system where you
      can get your crew on board, set the project's budget, schedule
      production events in a calendar, and point production locations on
      a map. Also, the app features a chat module and contracts with
      payment integration.
    </p>
    <p>
      My part was the entire API for an app and an Admin UI.
      Specifically:
      <ul>
        <li>Admin Web UI for managing user accounts.</li>
        <li>
          Managing app access (registration/login/profile completion).
        </li>
        <li>
          User profile features (profile info, showcasing projects, and
          work examples).
        </li>
        <li>
          Project module with access restrictions for collaborators +
          regular cast + guests.
        </li>
        <li>
          Project budget, shooting locations, calendar (production events
          with dates), and more.
        </li>
        <li>
          Internal chat module for users' communication (1-1 chat, group
          chats).
        </li>
        <li>
          Proposal/Contract logic to get users on board in a project team.
        </li>
        <li>
          Payment system integration to handle user-to-user payments.
        </li>
      </ul>
    </p>
    <p>
      As of now - we are close to the finish line and polishing the app
      before the release.
    </p>

    <template v-slot:footer>
      <div class="col-12 mt-3 py-2 next-btn next-btn__dark">
        <router-link :to="`/portfolio/rodrix`">
          <span>Next - Rodrix</span>
          <font-awesome-icon icon="arrow-right" size="3x" />
        </router-link>
      </div>
    </template>
  </product>
</template>

<script>
import Product from '@/components/product/Product'
export default {
  components: { Product },
  data() {
    return {
      productLogo: require('@/assets/img/products/ONE-App.png'),
      productBrief: 'A job marketplace for people in the film industry.',
      carouselImages: [
        require('@/assets/img/products/one/1.png'),
        require('@/assets/img/products/one/4.png'),
        require('@/assets/img/products/one/3.png'),
        require('@/assets/img/products/one/2.png'),
        require('@/assets/img/products/one/5.png'),
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
section.main {
  background-image: linear-gradient(#00000078, #0000007d),
    url("~@/assets/img/products/one/cover.jpg");
  background-position-x: right;
}
</style>
